import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../component-base.component';
import { ListRetrieverService } from '../../_services/list-retriever.service';
import { Option } from '../../_models/option';
import { Utils } from '../../utils';
import { AppInjector } from '../../_helpers/app-injector';
import { RoutingParameterService } from '../../_services/routing-parameters.service';

@Component({
  selector: 'app-waiting',
  templateUrl: './waiting.component.html',
  styleUrls: ['./waiting.component.css']
})
export class WaitingComponent{

  urlToReturn: string;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
  ) {
    this.urlToReturn="/";
    let routingParameterService: RoutingParameterService=AppInjector.get(RoutingParameterService);
    if(routingParameterService.parameters!=null && routingParameterService.parameters.urlToReturn!=null)
    {
      this.urlToReturn=routingParameterService.parameters.urlToReturn;
    }
    routingParameterService.clear();
    setTimeout(() => {
      this.router.navigate([this.urlToReturn]);
    }, 500);

  }


}



// WEBPACK FOOTER //
// ./src/app/components/waiting/waiting.component.ts